export const EXCMAGREEMENTTYPE_DELETE_RESET = 'EXCMAGREEMENTTYPE_DELETE_RESET'
export const EXCMAGREEMENTTYPE_DELETE_SET_ERROR = 'EXCMAGREEMENTTYPE_DELETE_SET_ERROR'
export const EXCMAGREEMENTTYPE_DELETE_SET_DELETED = 'EXCMAGREEMENTTYPE_DELETE_SET_DELETED'
export const EXCMAGREEMENTTYPE_DELETE_TOGGLE_LOADING = 'EXCMAGREEMENTTYPE_DELETE_TOGGLE_LOADING'
